

// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import { LanguageContext } from "../Components/LanguageContext";

// export default function RunningCard({ runnig, winnAmount, game_type }) {
//   const user = localStorage.getItem("userId");

//   // Language translations
//   const translations = {
//     hi: {
//       view: "देखे",
//       prize: "Winning Prize",
//       entry: "Entry Fee",
//     },
//     en: {
//       view: "view",
//       entry: "Entry Fee",
//       prize: "Winning Prize",
//     },
//   };

//   const { language } = useContext(LanguageContext);

//   const creatorName =
//     runnig?.Created_by?.Name?.length > 7
//       ? `${runnig.Created_by.Name.slice(0, 7)}...`
//       : runnig?.Created_by?.Name;

//   const acceptorName =
//     runnig?.Accepetd_By?.Name?.length > 7
//       ? `${runnig.Accepetd_By.Name.slice(0, 7)}...`
//       : runnig?.Accepetd_By?.Name;

//   return (
//     <div className="running-battle-card">
//       {/* Top Header Bar */}
//       <div className="running-card-header">
//         <span className="game-play-title">
//           Game Play between <strong className="player-name">{creatorName}</strong> &{" "}
//           <strong className="player-name">{acceptorName}</strong>
//         </span>
//       </div>

//       {/* Main Card Body */}
//       <div className="running-card-body">
//         {/* Entry Fee Section */}
//         <div className="fee-column left">
//           <span className="fee-label">{translations[language].entry}</span>
//           <div className="fee-amount-row">
//             <img src="/images/purse.png" alt="cash" className="cash-icon" />
//             <span className="fee-amount">{runnig?.Game_Ammount}</span>
//           </div>
//         </div>

//         {/* Center Versus or View Button */}
//         <div className="center-action-col">
//           {user === runnig?.Accepetd_By?._id || user === runnig?.Created_by?._id ? (
//             <Link
//               className={`btn-view-match ${
//                 runnig?.Status === "conflict" ? "conflict" : "active"
//               }`}
//               to={{
//                 pathname: `/viewgame1/${runnig?._id}`,
//                 state: { prevPath: window.location.pathname },
//               }}
//             >
//               {translations[language].view}
//             </Link>
//           ) : (
//             <div className="vs-badge-wrapper">
//               <img
//                 className="vs-icon"
//                 src={process.env.PUBLIC_URL + "/vsr.gif"}
//                 alt="VS"
//               />
//             </div>
//           )}
//         </div>

//         {/* Winning Prize Section */}
//         <div className="fee-column right">
//           <span className="fee-label">{translations[language].prize}</span>
//           <div className="fee-amount-row justify-end">
//             <img src="/images/purse.png" alt="cash" className="cash-icon" />
//             <span className="fee-amount">
//               {runnig?.Game_Ammount + winnAmount(runnig?.Game_Ammount)}
//             </span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import { Zap, Eye } from "lucide-react";
// import "../css/RunningCard.css";

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");

  // Language translations
  const translations = {
    hi: {
      view: "देखे",
      prize: "PRIZE",
      entry: "ENTRY",
    },
    en: {
      view: "View",
      entry: "ENTRY",
      prize: "PRIZE",
    },
  };

  const { language } = useContext(LanguageContext);

  const creatorName =
    runnig?.Created_by?.Name?.length > 12
      ? `${runnig.Created_by.Name.slice(0, 12)}...`
      : runnig?.Created_by?.Name || "Player 1";

  const acceptorName =
    runnig?.Accepetd_By?.Name?.length > 12
      ? `${runnig.Accepetd_By.Name.slice(0, 12)}...`
      : runnig?.Accepetd_By?.Name || "Player 2";

  // Helper for generating player avatar initials
  const getInitials = (name) => {
    if (!name) return "P";
    const parts = name.trim().split(" ");
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.slice(0, 2).toUpperCase();
  };

  const isUserParticipant =
    user === runnig?.Accepetd_By?._id || user === runnig?.Created_by?._id;

  return (
    <div className="ce-running-battle-card ce-running-slide-left">
      {/* Top Bar: LIVE Status Badge & ENTRY/PRIZE Badges */}
      <div className="ce-running-card-top">
        <div className="ce-live-status-pill">
          <span className="ce-live-dot"></span>
          <span>LIVE</span>
        </div>

        <div className="ce-running-pills-group">
          <div className="ce-running-badge entry">
            <span className="ce-badge-lbl">{translations[language].entry}</span>
            <span className="ce-badge-val">₹{runnig?.Game_Ammount}</span>
          </div>
          <div className="ce-running-badge prize">
            <span className="ce-badge-lbl">{translations[language].prize}</span>
            <span className="ce-badge-val">
              ₹{runnig?.Game_Ammount + winnAmount(runnig?.Game_Ammount)}
            </span>
          </div>
        </div>
      </div>

      {/* Main Players VS / Action Bar */}
      <div className="ce-running-players-row">
        {/* Creator Info */}
        <div className="ce-player-box left">
          <div className="ce-player-avatar">
            {getInitials(runnig?.Created_by?.Name)}
          </div>
          <span className="ce-player-name">{creatorName}</span>
        </div>

        {/* Center VS Badge / View Action Button */}
        <div className="ce-running-center-col">
          {isUserParticipant ? (
            <Link
              className={`ce-btn-view-match ${
                runnig?.Status === "conflict" ? "conflict" : "active"
              }`}
              to={{
                pathname: `/viewgame1/${runnig?._id}`,
                state: { prevPath: window.location.pathname },
              }}
            >
              <Eye size={14} />
              <span>{translations[language].view}</span>
            </Link>
          ) : (
            <div className="ce-vs-badge">VS</div>
          )}
        </div>

        {/* Acceptor Info */}
        <div className="ce-player-box right">
          <span className="ce-player-name">{acceptorName}</span>
          <div className="ce-player-avatar acceptor">
            {getInitials(runnig?.Accepetd_By?.Name)}
          </div>
        </div>
      </div>
    </div>
  );
}